import React from 'react';
import { TitleHeader } from 'web-library';
import { useHistory, useLocation } from 'react-router-dom';
import IndividualResultRelease from '../../../modules/result/IndividualResultRelease';
import * as QUERIES from '../../../api/candidate/result/@opadmin/queries-services/queries';
import RouteKey from '../../../routes/key';

const { admin } = RouteKey.child;
const { orgAdminResultRelease } = RouteKey.admin.child;

const OrgAdminIndividualResultRelease = () => {
  const { state } = useLocation<any>();
  const history = useHistory();

  if (!state || state.indexNo === undefined) {
    history.push(`/${admin}/${orgAdminResultRelease.route}`);
  }

  const { data } = QUERIES.useGetOrgAdminResultReleaseByIndexNo(state?.indexNo, {
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    enabled: state && state.indexNo !== undefined,
  });

  return (
    <>
      <TitleHeader title="Results" />
      {data && <IndividualResultRelease candidateResultData={data} eligibleForResit={false} />}
    </>
  );
};
export default OrgAdminIndividualResultRelease;
